import { COLORS, FONTS } from 'constants/index';
import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
    paper: {
        height: 'auto',
        maxWidth: 418,
        minHeight: 418,
        padding: 16,
        paddingTop: 20,
        paddingBottom: 12,
        [theme.breakpoints.up('md')]: {
            width: '100%'
        }
    },
    fullScreenPaper: {
        height: '100% !important',
        maxWidth: '100% !important'
    },
    button: {
        textTransform: 'none'
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start'
        },
        padding: 0,
        marginBottom: 40
    },
    titleText: {
        fontFamily: FONTS.SECONDARY_FONT,
        fontStyle: 'normal',
        fontSize: 14,
        textAlign: 'center',
        color: COLORS.apariBlack80
    },
    backdrop: {
        opacity: '0.8 !important',
        background: COLORS.backgroundTransparentWhite,
        backdropFilter: 'blur(4px)'
    },
    textContainer: {
        width: '100%',
        maxWidth: 380
    },
    buttonContainer: {
        marginTop: 'auto'
    }
}));
